export const SET_EMPLOYEES = 'SET_EMPLOYEES';
export const SET_BRANCHS = 'SET_BRANCHS';
export const SET_POSITION = 'SET_POSITION';
export const SET_ADDRESSBOOKS = 'SET_ADDRESSBOOKS';
export const SET_MARKETING_PERSONS = 'SET_MARKETING_PERSONS';
export const SET_CLEARENCES = 'SET_CLEARENCES';
export const SET_ESTIMATED_TIMES = 'SET_ESTIMATED_TIMES';
export const SET_BASIC_FREIGHT_VALUES = 'SET_BASIC_FREIGHT_VALUES';
